let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("30cOr")).then(() => parcelRequire('9JYSt'));